import React from 'react';
import PropTypes from 'prop-types';

import { Form } from 'common/components';

import Validated from 'components/util/Validated';
import AuthSchemas from 'schemas/auth_schemas';

const ResetPasswordForm = ({
  values = { password: '' },
  handleValueChange,
  handleSubmit,
  errors = {},
  isSubmitted = false,
  isLoading = false,
  t = (arg) => arg,
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row">
        <div className="col-12">
          <Form.FieldInput
            value={values.password}
            type={'password'}
            name={'password'}
            placeholder={t('reset_password.fields.password')}
            error={(isSubmitted && errors.password) || {}}
            errorPrefix={'reset_password.password'}
            handleChange={handleValueChange}
            inputSize={'lg'}
            iconLeft={'lock'}
            iconRightSize={'lg'}
            t={t}
            autoFocus={true}
          />
        </div>

        <div className="col-md-12">
          <Form.Button
            text={t('reset_password.fields.submit')}
            isLoading={isLoading}
            extraClassName={'btn-lg pull-right btn-md-block'}
          />

          <Form.Link to={'/auth/login'} className="btn btn-lg btn-link pull-right btn-md-block">
            {t('reset_password.fields.login')}
          </Form.Link>
        </div>
      </div>
    </form>
  );
};

ResetPasswordForm.propTypes = {
  values: PropTypes.shape({
    password: PropTypes.string.isRequired,
  }).isRequired,
  handleValueChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  errors: PropTypes.object,
  isSubmitted: PropTypes.bool,
  isLoading: PropTypes.bool,
  t: PropTypes.func,
};

export default Validated(AuthSchemas.reset_password)(ResetPasswordForm);



// WEBPACK FOOTER //
// src/modules/auth/components/form/ResetPasswordForm.js